import { ImageIcon } from '@vlabs/icons';
import { useTranslation } from 'react-i18next';

import { SUPPORTED_IMAGE_MIME_TYPES } from './constants';

export function DefaultCaption() {
  const { t } = useTranslation();
  const SUPPORTED_TYPES_FOR_CAPTION = SUPPORTED_IMAGE_MIME_TYPES.map((mimeType) => mimeType.replace('image/', ''));

  return (
    <div className="FileDropzone__Caption">
      <ImageIcon />

      <span className="FileDropzone__CaptionTitle">
        {t('shared:drag_or_click_file')}
      </span>

      <span className="FileDropzone__CaptionDescription">
        {t(
          'checks:image checks.form.dropzone.supported types',
          { supportedTypes: SUPPORTED_TYPES_FOR_CAPTION.join(', ') },
        )}
      </span>
    </div>
  );
}
